export default __webpack_public_path__ + "static/media/legacy-yen-tu-slider.285790af.jpg";